module.exports = __webpack_public_path__ + "img/ai.307294bc.svg";